const ENProjectsPanel = {
	"Aberta": "Open",
	"Ação sucessora não pode pertencer a um projeto diferente de sua predecessora": "Successor action cannot belong to a different project than its predecessor",
	"Ação sucessora não pode ter data de inicio ou fim antes de sua predecessora": "Successor action cannot have a start or end date before its predecessor",
	"Ações Concluídas": "Completed Actions",
	"Ações liberadas com sucesso": "Actions successfully released",
	"Adicionar Ação": "Add Action",
	"Adicionar Projeto": "Add Project",
	"Agora clique sobre a barra que representa a ação sucessora": "Now click on the bar that represents the successor action",
	"Aplicar": "Apply",
	"Aplicar em todas as ações": "Apply to all actions",
	"Basta executar o mesmo processo feito para vincular": "Just run the same process you did for linking",
	"Concluído": "Completed",
	"Copiar Projeto": "Copy Project",
	"concluído(s)": "conclued",
	"Dê um clique duplo sobre a barra que representa a ação predecessora. Você vai notar que a borda da barra fica vermelha": "Double click on the bar representing the predecessor action. You will notice that the border of the bar turns red",
	"Deseja realmente excluir a Sprint?": "Do you really want to delete Sprint?",
	"Desvincular ações": "Unlink actions",
	"Editar Sprint": "Edit Sprint",
	"Em caso de erro, será indicado na mensagem de erro": "In case of error, it will be indicated in the error message",
	"Em caso de sucesso, você vai perceber que uma linha vermelha é desenhada partindo da ação predecessora até sua sucessora": "In case of success, you will notice that a red line is drawn from the predecessor action to its successor",
	"Erro ao adicionar ação subsequente": "Error adding subsequent action",
	"Erro ao buscar detalhes": "Error fetching details",
	"Erro ao buscar dados de Horas de Projetos": "Error fetching Project Hours data",
	"Erro ao excluir Sprint": "Error deleting Sprint",
	"Erro ao liberar ações": "Error releasing actions",
	"Estimada": "Estimated",
	"Estimado": "Estimated",
	"Excluir Sprint": "Delete Sprint",
	"Exclusão de Sprint": "Sprint deletion",
	"Fechada": "Closed",
	"Iniciar tarefa": "Start task",
	"Horas do Projeto": "Project Hours",
	"Instruções para vincular ações": "Instructions for linking actions",
	"Liberar Ações": "Release Actions",
	"Liberar Ações em Rascunho": "Release Actions in Draft",
	"Meus Projetos": "My Projects",
	"Novo Programa": "New Program",
	"Pausar tarefa": "Pause task",
	"Painel de Projetos": "Panel of Projects",
	"Prevista": "Foreseen",
	"Previsto (Ações)": "Foreseen (Actions)",
	"Real": "Real",
	"Real (Ações)": "Real (Actions)",
	"Reordenar Programas": "Reorder Programs",
	"Sprint excluída com sucesso": "Sprint deleted successfully",
	"Todos Projetos": "All Projects",
	"Valor Despesa": "Expense amount",
	"Valor Receita": "Revenue Value",
	"Vincular ações": "Link actions"
};

export default ENProjectsPanel;
